import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ProfileComponent } from './profile/profile.component';
import {
  autoLoginPartialRoutesGuard,
} from 'angular-auth-oidc-client';
import { AccessDeniedComponent } from './shared/components/access-denied/access-denied.component';

const routes: Routes = [
  {
    path: 'course/list',
    loadChildren: () =>
      import('./pages/course-list/course-list.module').then(
        (m) => m.CourseListModule
      ),
    canActivate: [autoLoginPartialRoutesGuard],
  },
  {
    path: 'auxiliary-course/list',
    loadChildren: () =>
      import('./pages/auxiliary-course-list/auxiliary-course-list.module').then(
        (m) => m.AuxiliaryCourseListModule
      ),
    canActivate: [autoLoginPartialRoutesGuard],
  },
  {
    path: 'faculty',
    loadChildren: () =>
      import('./pages/faculty-mapping/faculty-mapping.module').then(
        (m) => m.FacultyMappingModule
      ),
    canMatch: [autoLoginPartialRoutesGuard]
  },
  {
    path: 'contract/instructor',
    loadChildren: () =>
      import('./pages/contract-instructor/contract-instructor.module').then(
        (m) => m.ContractInstructorModule
      ),
    canMatch: [autoLoginPartialRoutesGuard]
  },
  {
    path: 'staff-role/overrides',
    loadChildren: () =>
      import('./pages/staff-role-override/staff-role-override.module').then(
        (m) => m.StaffRoleOverrideModule
      ),
    canMatch: [autoLoginPartialRoutesGuard]
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./pages/admin/admin.module').then(
        (m) => m.AdminModule
      ),
    canMatch: [autoLoginPartialRoutesGuard]
  },
  {
    path: 'user',
    loadChildren: () =>
      import('./pages/user/user.module').then(
        (m) => m.UserModule
      ),
    canMatch: [autoLoginPartialRoutesGuard]
  },
  {
    path: 'sync',
    loadChildren: () =>
      import('./pages/full-sync/full-sync.module').then(
        (m) => m.FullSyncModule
      ),
    canMatch: [autoLoginPartialRoutesGuard]
  },
  {
    path: 'course-detail',
    loadChildren: () =>
      import('./pages/course-detail/course-detail.module').then(
        (m) => m.CourseDetailModule
      ),
    canMatch: [autoLoginPartialRoutesGuard]
  },
  {
    path: 'auxiliary-course-detail',
    loadChildren: () =>
      import('./pages/auxiliary-course-detail/auxiliary-course-detail.module').then(
        (m) => m.AuxiliaryCourseDetailModule
      ),
    canActivate: [autoLoginPartialRoutesGuard],
  },
  {
    path: 'profile',
    component: ProfileComponent
  },
  {
    path: 'home',
    pathMatch: 'full',
    redirectTo: ''
  },
  {
    path: '',
    component: HomeComponent,
  },
  {
    // Needed for Error routing
    path: 'error',
    component: HomeComponent
  },
  { 
    path: 'access-denied', 
    component: AccessDeniedComponent 
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
